module.exports = __webpack_public_path__ + "static/media/lock.58ddf644.png";